import { render, staticRenderFns } from "./ChapterMaterialManage.vue?vue&type=template&id=f1c633da"
import script from "./ChapterMaterialManage.vue?vue&type=script&lang=js"
export * from "./ChapterMaterialManage.vue?vue&type=script&lang=js"
import style0 from "./ChapterMaterialManage.vue?vue&type=style&index=0&id=f1c633da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports